/* WEC · Visor 3D MODbox — mismos modelos del video/GIF (THREE r128 + RoundedBoxGeometry + RoomEnvironment) */
(function(){
  var host = document.getElementById('mbx-3d');
  if (!host || !window.THREE || !THREE.RoundedBoxGeometry) { window.MBX3D = { update: function(){} }; return; }
  var T = THREE;
  var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.toneMapping = T.LinearToneMapping; renderer.toneMappingExposure = 0.82;
  renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
  renderer.setClearColor(0x000000, 0);
  host.appendChild(renderer.domElement);
  var scene = new T.Scene();
  var pm = new T.PMREMGenerator(renderer);
  scene.environment = pm.fromScene(new T.RoomEnvironment(), 0.04).texture;
  var camera = new T.PerspectiveCamera(26, 1, 0.1, 200);
  var key = new T.DirectionalLight(0xffffff, 1.25); key.position.set(-5, 8, 8); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048); key.shadow.radius = 6; key.shadow.bias = -0.0004; key.shadow.normalBias = 0.02;
  var sc = key.shadow.camera; sc.left = -8; sc.right = 8; sc.top = 9; sc.bottom = -2; sc.near = 1; sc.far = 40;
  scene.add(key);
  var rim = new T.DirectionalLight(0xfff2e6, 0.6); rim.position.set(6, 5, -6); scene.add(rim);
  scene.add(new T.HemisphereLight(0xffffff, 0xd8dbe0, 0.35));
  var ground = new T.Mesh(new T.PlaneGeometry(60, 60), new T.ShadowMaterial({ opacity: 0.2 }));
  ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

/* ---------- materiales (colores tomados de las fotos de producto) ---------- */
var tl = new T.TextureLoader();
function decal(src){ var t = tl.load(src); t.encoding = T.sRGBEncoding; t.anisotropy = 8; return new T.MeshStandardMaterial({ map: t, roughness: 0.6 }); }
function noiseTex(rep){ var c = document.createElement('canvas'); c.width = c.height = 256; var x = c.getContext('2d'), d = x.createImageData(256, 256);
  for (var i = 0; i < d.data.length; i += 4){ var v = 200 + Math.random() * 55; d.data[i] = d.data[i+1] = d.data[i+2] = v; d.data[i+3] = 255; }
  x.putImageData(d, 0, 0); var t = new T.CanvasTexture(c); t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(rep, rep); return t; }
var grain = noiseTex(6);
function plastic(hex, rough){ return new T.MeshStandardMaterial({ color: hex, roughness: rough, roughnessMap: grain }); }
function badgeMat(kind){
  var c = document.createElement('canvas'), x = c.getContext('2d');
  if (kind === 'klein'){
    c.width = 256; c.height = 138; x.fillStyle = '#1a1b1d'; x.fillRect(0, 0, 256, 138);
    x.beginPath(); x.moveTo(40, 14); x.lineTo(216, 14); x.lineTo(244, 69); x.lineTo(216, 124); x.lineTo(40, 124); x.lineTo(12, 69); x.closePath();
    x.lineWidth = 7; x.strokeStyle = '#e0702a'; x.stroke();
    x.fillStyle = '#ffffff'; x.textAlign = 'center'; x.font = 'bold 44px Georgia, "Times New Roman", serif';
    x.fillText('KLEIN', 128, 64); x.fillText('TOOLS', 128, 108);
  } else {
    c.width = 160; c.height = 124; x.fillStyle = '#1a1b1d'; x.fillRect(0, 0, 160, 124);
    x.strokeStyle = '#ffffff'; x.lineWidth = 12; x.beginPath(); x.moveTo(30, 14); x.lineTo(130, 110); x.moveTo(130, 14); x.lineTo(30, 110); x.stroke();
    x.fillStyle = '#ffffff'; x.fillRect(46, 30, 68, 64); x.fillStyle = '#1a1b1d'; x.textAlign = 'center'; x.font = 'bold 30px Arial, sans-serif';
    x.fillText('MOD', 80, 58); x.fillText('BOX', 80, 88);
  }
  var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.anisotropy = 8;
  return new T.MeshStandardMaterial({ map: t, roughness: 0.6 });
}
var M = {
  orange: plastic(0xe0702a, 0.62),      // naranja Klein mate de los costados
  orangeD: plastic(0xc95f22, 0.7),      // facetas en sombra / bandejas
  bin: plastic(0xd8662a, 0.7),         // separadores internos
  lid: plastic(0x3b3d3f, 0.7),          // tapa gris carbón
  black: plastic(0x262728, 0.6),        // frentes de gaveta
  blackD: plastic(0x161718, 0.75),      // huecos / jaladores
  rubber: plastic(0x1e1e1e, 0.9),
  metal: new T.MeshStandardMaterial({ color: 0xd9dcdf, roughness: 0.18, metalness: 1 }),
  red: plastic(0xd8432a, 0.5),
  clear: new T.MeshPhysicalMaterial({ color: 0xffe6d6, roughness: 0.04, transparent: true, opacity: 0.14, clearcoat: 1, depthWrite: false, side: T.DoubleSide }),
  klein: badgeMat('klein'), modbx: badgeMat('mod')
};
Object.keys(M).forEach(function(k){ if (k !== 'klein' && k !== 'modbx') M[k].color.convertSRGBToLinear(); M[k].envMapIntensity = 0.55; });
function rb(w, h, d, r, mat, x, y, z, g, seg){
  var m = new T.Mesh(new T.RoundedBoxGeometry(w, h, d, seg || 3, Math.min(r, w / 2 - .001, h / 2 - .001, d / 2 - .001)), mat);
  m.position.set(x, y, z); m.castShadow = m.receiveShadow = true; g.add(m); return m;
}
function plane(w, h, mat, x, y, z, g){ var m = new T.Mesh(new T.PlaneGeometry(w, h), mat); m.position.set(x, y, z); g.add(m); return m; }
/* prisma a partir de un polígono 2D (x,y), extruido en z */
function prism(pts, depth, mat, x, y, z, g, bevel){
  var sh = new T.Shape(); sh.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) sh.lineTo(pts[i][0], pts[i][1]);
  var geo = new T.ExtrudeGeometry(sh, { depth: depth, bevelEnabled: !!bevel, bevelSize: bevel || 0, bevelThickness: bevel || 0, bevelSegments: 2 });
  var m = new T.Mesh(geo, mat); m.position.set(x, y, z); m.castShadow = m.receiveShadow = true; g.add(m); return m;
}
var W = 2.2, D = 1.5;

/* tapa gris carbón: esquinas achaflanadas, 4 ranuras, botón rojo de seguro */
function topCap(g, h){
  var c = 0.16, w = W / 2 + 0.03, d = D / 2 + 0.03;
  var pts = [[-w + c, -d], [w - c, -d], [w, -d + c], [w, d - c], [w - c, d], [-w + c, d], [-w, d - c], [-w, -d + c]];
  var lid = prism(pts, 0.17, M.lid, 0, h, 0, g, 0.025); lid.rotation.x = Math.PI / 2;
  [[-0.5, 0.36], [0.5, 0.36], [-0.5, -0.36], [0.5, -0.36]].forEach(function(p){ rb(0.66, 0.03, 0.13, 0.015, M.blackD, p[0], h + 0.012, p[1], g); });
  rb(W - 0.3, 0.07, 0.04, 0.015, M.blackD, 0.1, h - 0.13, D / 2 + 0.035, g);           // franja frontal
  var btn = new T.Mesh(new T.CylinderGeometry(0.045, 0.045, 0.04, 20), M.red); btn.rotation.x = Math.PI / 2;
  btn.position.set(-W / 2 + 0.42, h - 0.13, D / 2 + 0.06); g.add(btn);
}
function feet(g){
  rb(W - 0.1, 0.07, D - 0.1, 0.03, M.blackD, 0, 0.035, 0, g);
  [[1, 1], [-1, 1], [1, -1], [-1, -1]].forEach(function(c){ rb(0.26, 0.11, 0.26, 0.04, M.lid, c[0] * (W / 2 - 0.14), 0.055, c[1] * (D / 2 - 0.14), g); });
}
/* cuerpo naranja con facetas y franja estriada en los costados */
function body(g, y0, h){
  rb(W, h, D, 0.07, M.orange, 0, y0 + h / 2, 0, g);
  [-1, 1].forEach(function(s){
    rb(0.02, h * 0.62, D * 0.62, 0.01, M.orangeD, s * (W / 2 + 0.005), y0 + h * 0.48, -0.04, g);      // panel hundido
    rb(0.04, 0.13, D * 0.8, 0.02, M.orange, s * (W / 2 + 0.01), y0 + h * 0.5, -0.02, g);              // franja
    for (var z = -D * 0.38; z < D * 0.38; z += 0.045) rb(0.05, 0.08, 0.018, 0.006, M.orangeD, s * (W / 2 + 0.02), y0 + h * 0.5, z, g);
  });
}
/* frente de gaveta negro facetado con jalador central */
function drawerFront(g, y, hh, z, badge){
  var w = W - 0.24, grp = new T.Group(); grp.position.set(0, y, z); g.add(grp);
  var c = Math.min(0.08, hh * 0.25);
  var pts = [[-w / 2, -hh / 2], [w / 2, -hh / 2], [w / 2, hh / 2 - c], [w / 2 - c, hh / 2], [-w / 2 + c, hh / 2], [-w / 2, hh / 2 - c]];
  prism(pts, 0.08, M.black, 0, 0, 0, grp, 0.012);
  [-1, 1].forEach(function(s){                                                   // paneles laterales en relieve
    var pw = w * 0.3, x0 = s * (w / 2 - 0.05 - pw / 2);
    var p = [[-pw / 2, -hh * 0.36], [pw / 2, -hh * 0.36], [pw / 2, hh * 0.34], [-pw / 2, hh * 0.34]];
    if (s < 0) p[2][0] -= pw * 0.18; else p[3][0] += pw * 0.18;
    prism(p, 0.02, M.black, x0, 0, 0.085, grp, 0.006);
  });
  var tw = w * 0.34, th = hh * 0.34;                                            // jalador trapezoidal
  prism([[-tw / 2, -th / 2], [tw / 2, -th / 2], [tw / 2 - th * 0.5, th / 2], [-tw / 2 + th * 0.5, th / 2]], 0.03, M.blackD, 0, -hh * 0.16, 0.07, grp, 0.006);
  if (badge === 'klein') plane(Math.min(0.46, hh * 1.0), Math.min(0.46, hh * 1.0) * 0.54, M.klein, 0, hh * 0.17, 0.115, grp);
  if (badge === 'mod') plane(Math.min(0.16, hh * 0.42), Math.min(0.16, hh * 0.42) * 0.78, M.modbx, 0, hh * 0.15, 0.115, grp);
  return grp;
}
/* bandejas naranja dentro de la gaveta (visibles al abrir) */
function bins(grp, hh){
  var w = W - 0.34, dd = D - 0.3;
  rb(w, 0.04, dd, 0.01, M.blackD, 0, -hh / 2 + 0.06, -dd / 2, grp);
  [-1, 1].forEach(function(s){ rb(0.04, hh * 0.8, dd, 0.01, M.black, s * w / 2, -0.02, -dd / 2, grp); });
  for (var i = 0; i < 3; i++) for (var j = 0; j < 2; j++)
    rb(w / 3 - 0.05, hh * 0.62, dd / 2 - 0.05, 0.02, M.bin, -w / 3 + i * w / 3, -hh / 2 + 0.06 + hh * 0.31, -dd / 4 - j * dd / 2, grp);
}
function latches(g, h){
  var L = [];
  [-1, 1].forEach(function(s){
    var p = new T.Group(); p.position.set(s * (W / 2 - 0.3), h - 0.24, D / 2 + 0.03);
    rb(0.26, 0.34, 0.07, 0.03, M.black, 0, 0.17, 0.035, p);
    for (var i = -1; i <= 1; i++) rb(0.045, 0.18, 0.02, 0.008, M.blackD, i * 0.07, 0.13, 0.075, p);
    rb(0.24, 0.035, 0.05, 0.015, M.metal, 0, 0.33, 0.045, p);
    g.add(p); L.push(p);
  });
  g.userData.latches = L;
}
function drawerUnit(n, h){
  var g = new T.Group(); feet(g);
  body(g, 0.07, h - 0.24);
  topCap(g, h);
  var y0 = 0.13, avail = h - 0.4, each = avail / n;
  rb(W - 0.2, avail + 0.03, 0.06, 0.02, M.blackD, 0, y0 + avail / 2, D / 2 - 0.01, g);
  g.userData.drawers = [];
  for (var i = 0; i < n; i++){
    var y = y0 + each * (n - i - 0.5);
    var f = drawerFront(g, y, each - 0.035, D / 2 - 0.03, i === 0 ? 'klein' : (i === n - 1 ? 'mod' : null));
    bins(f, each - 0.035); g.userData.drawers.push(f);
  }
  latches(g, h); g.userData.h = h; return g;
}
function rollingBase(){
  var g = new T.Group(), lift = 0.16, h = 1.62;
  var b = new T.Group(); b.position.y = lift; g.add(b);
  rb(W - 0.1, 0.08, D - 0.1, 0.03, M.blackD, 0, 0.04, 0, b);
  body(b, 0.06, h - 0.24);
  topCap(b, h);
  // dos gavetas: llana arriba, honda abajo
  rb(W - 0.2, h - 0.42, 0.06, 0.02, M.blackD, 0, 0.12 + (h - 0.42) / 2, D / 2 - 0.01, b);
  var f1 = drawerFront(b, h - 0.53, 0.36, D / 2 - 0.03, null); bins(f1, 0.36);
  var f2 = drawerFront(b, 0.12 + 0.39, 0.76, D / 2 - 0.03, null); bins(f2, 0.76);
  plane(0.36, 0.36 * 0.54, M.klein, 0, 0.17, 0.115, f2); plane(0.14, 0.14 * 0.78, M.modbx, 0, 0.03, 0.115, f2);
  b.userData.drawers = [f1, f2];
  latches(b, h); g.userData.latches = b.userData.latches; g.userData.drawers = b.userData.drawers;
  // ruedas con rayos
  [-1, 1].forEach(function(s){
    var wg = new T.Group(); wg.position.set(s * (W / 2 + 0.08), 0.4, -D / 2 + 0.34); g.add(wg);
    var tire = new T.Mesh(new T.TorusGeometry(0.33, 0.08, 16, 40), M.rubber); tire.rotation.y = Math.PI / 2; tire.castShadow = true; wg.add(tire);
    var disc = new T.Mesh(new T.CylinderGeometry(0.33, 0.33, 0.12, 40), M.lid); disc.rotation.z = Math.PI / 2; wg.add(disc);
    for (var k = 0; k < 6; k++){ var sp = rb(0.03, 0.5, 0.07, 0.01, M.blackD, s * 0.065, 0, 0, wg); sp.rotation.x = k * Math.PI / 6; }
    var hub = new T.Mesh(new T.CylinderGeometry(0.08, 0.08, 0.16, 20), M.blackD); hub.rotation.z = Math.PI / 2; wg.add(hub);
  });
  [-1, 1].forEach(function(s){ rb(0.26, 0.17, 0.26, 0.04, M.lid, s * (W / 2 - 0.2), 0.085, D / 2 - 0.24, g); });
  // manubrio telescópico: tubos negros, travesaño gris, empuñadura con tapas naranja
  var hd = new T.Group(); hd.position.set(0, lift + 0.3, -D / 2 - 0.12); g.add(hd);
  [-1, 1].forEach(function(s){ rb(0.11, 1, 0.11, 0.025, M.black, s * 0.8, 0.5, 0, hd).name = 'tube'; });
  var grip = new T.Group(); grip.name = 'grip'; hd.add(grip);
  rb(1.5, 0.12, 0.14, 0.05, M.blackD, 0, 0, 0, grip);
  [-1, 1].forEach(function(s){ rb(0.24, 0.17, 0.2, 0.05, M.orange, s * 0.8, 0, 0, grip); });
  g.userData.handle = hd; g.userData.h = h + lift; return g;
}
function compBox(){
  var g = new T.Group(), h = 0.6;
  rb(W - 0.1, 0.06, D - 0.1, 0.03, M.orangeD, 0, 0.03, 0, g);
  rb(W, 0.3, D, 0.06, M.orange, 0, 0.21, 0, g);
  [-1, 1].forEach(function(s){ for (var y = 0.1; y < 0.34; y += 0.06) rb(0.02, 0.025, D * 0.86, 0.008, M.orangeD, s * (W / 2 + 0.005), y, 0, g); });
  for (var i = 0; i < 2; i++) for (var j = 0; j < 3; j++)                      // compartimientos naranja
    rb(W / 2 - 0.12, 0.2, D / 3 - 0.08, 0.04, M.bin, -W / 4 + i * W / 2, 0.42, -D / 3 + j * D / 3, g);
  var lid = rb(W + 0.02, 0.24, D + 0.02, 0.05, M.clear, 0, 0.48, 0, g, 2); lid.castShadow = false;
  rb(0.03, 0.22, D - 0.1, 0.01, M.clear, 0, 0.48, 0, g);
  // jalador negro central
  var hb = new T.Group(); hb.position.set(0, 0.22, D / 2 + 0.02); g.add(hb);
  rb(0.62, 0.2, 0.08, 0.03, M.orangeD, 0, 0, -0.02, hb); rb(0.56, 0.08, 0.1, 0.035, M.blackD, 0, -0.04, 0.04, hb);
  // cierres de alambre sobre bloque negro
  [-1, 1].forEach(function(s){
    rb(0.26, 0.22, 0.06, 0.02, M.black, s * 0.68, 0.22, D / 2 + 0.03, g);
    for (var k = -1; k <= 1; k++) rb(0.04, 0.12, 0.02, 0.006, M.blackD, s * 0.68 + k * 0.07, 0.2, D / 2 + 0.065, g);
    var wire = new T.Mesh(new T.TorusGeometry(0.13, 0.014, 8, 24, Math.PI), M.metal); wire.position.set(s * 0.68, 0.3, D / 2 + 0.07); g.add(wire);
  });
  g.userData.h = h; return g;
}


  /* ---------- piezas adicionales del catálogo ---------- */
  M.label = plastic(0xf1b634, 0.5);
  M.wireR = plastic(0xb8352a, 0.45); M.wireK = plastic(0x1b1b1b, 0.45); M.wireW = plastic(0xe8e8e8, 0.45);
  [M.label, M.wireR, M.wireK, M.wireW].forEach(function(m){ m.color.convertSRGBToLinear(); m.envMapIntensity = 0.55; });

  function plainBase(){            // KLE54802MB: caja rodante sin gavetas
    var g = new T.Group(), lift = 0.16, h = 1.5;
    var b = new T.Group(); b.position.y = lift; g.add(b);
    rb(W - 0.1, 0.08, D - 0.1, 0.03, M.blackD, 0, 0.04, 0, b);
    body(b, 0.06, h - 0.24); topCap(b, h);
    rb(W - 0.5, h - 0.6, 0.04, 0.04, M.orangeD, 0, 0.3 + (h - 0.6) / 2, D / 2 + 0.005, b);
    rb(W - 0.62, h - 0.72, 0.05, 0.04, M.orange, 0, 0.3 + (h - 0.6) / 2, D / 2 + 0.02, b);
    plane(0.5, 0.27, M.klein, 0, h * 0.56, D / 2 + 0.05, b); plane(0.16, 0.125, M.modbx, 0, h * 0.37, D / 2 + 0.05, b);
    latches(b, h); g.userData.latches = b.userData.latches;
    wheelsAndHandle(g, lift);
    g.userData.h = h + lift; return g;
  }
  function wheelsAndHandle(g, lift){
    [-1, 1].forEach(function(s){
      var wg = new T.Group(); wg.position.set(s * (W / 2 + 0.08), 0.4, -D / 2 + 0.34); g.add(wg);
      var tire = new T.Mesh(new T.TorusGeometry(0.33, 0.08, 16, 40), M.rubber); tire.rotation.y = Math.PI / 2; tire.castShadow = true; wg.add(tire);
      var disc = new T.Mesh(new T.CylinderGeometry(0.33, 0.33, 0.12, 40), M.lid); disc.rotation.z = Math.PI / 2; wg.add(disc);
      for (var k = 0; k < 6; k++){ var sp = rb(0.03, 0.5, 0.07, 0.01, M.blackD, s * 0.065, 0, 0, wg); sp.rotation.x = k * Math.PI / 6; }
    });
    [-1, 1].forEach(function(s){ rb(0.26, 0.17, 0.26, 0.04, M.lid, s * (W / 2 - 0.2), 0.085, D / 2 - 0.24, g); });
    var hd = new T.Group(); hd.position.set(0, lift + 0.3, -D / 2 - 0.12); g.add(hd);
    [-1, 1].forEach(function(s){ rb(0.11, 1, 0.11, 0.025, M.black, s * 0.8, 0.5, 0, hd).name = 'tube'; });
    var grip = new T.Group(); grip.name = 'grip'; hd.add(grip);
    rb(1.5, 0.12, 0.14, 0.05, M.blackD, 0, 0, 0, grip);
    [-1, 1].forEach(function(s){ rb(0.24, 0.17, 0.2, 0.05, M.orange, s * 0.8, 0, 0, grip); });
    g.userData.handle = hd;
  }
  function tub(h){                 // KLE54803MB / KLE54804MB: caja sin gavetas
    var g = new T.Group(); feet(g); body(g, 0.07, h - 0.24); topCap(g, h);
    rb(W - 0.5, h - 0.5, 0.04, 0.04, M.orangeD, 0, 0.1 + (h - 0.4) / 2 + 0.05, D / 2 + 0.005, g);
    var bw = Math.min(0.5, h * 0.55);
    plane(bw, bw * 0.54, M.klein, 0, h * 0.5, D / 2 + 0.03, g);
    latches(g, h); g.userData.h = h; return g;
  }
  function compHalf(){             // KLE54809MB: media anchura
    var g = new T.Group(), w = W / 2 - 0.03, h = 0.42;
    rb(w, 0.24, D, 0.05, M.orange, 0, 0.14, 0, g);
    for (var j = 0; j < 3; j++) rb(w - 0.14, 0.12, D / 3 - 0.08, 0.03, M.bin, 0, 0.3, -D / 3 + j * D / 3, g);
    var lid = rb(w + 0.02, 0.16, D + 0.02, 0.04, M.clear, 0, 0.34, 0, g, 2); lid.castShadow = false;
    rb(w + 0.03, 0.05, D + 0.03, 0.02, M.orange, 0, 0.26, 0, g);
    rb(0.26, 0.14, 0.05, 0.02, M.black, 0, 0.16, D / 2 + 0.03, g);
    g.userData.h = h; g.userData.half = true; return g;
  }
  function spool(){
    var g = new T.Group(), h = 1.15; feet(g);
    rb(W, 0.12, D, 0.04, M.orange, 0, 0.13, 0, g);
    [-1, 1].forEach(function(s){ rb(0.14, h - 0.2, D, 0.04, M.orange, s * (W / 2 - 0.07), 0.07 + (h - 0.2) / 2, 0, g); });
    rb(W, h - 0.3, 0.08, 0.03, M.orangeD, 0, h / 2, -D / 2 + 0.05, g);
    topCap(g, h);
    var rod = new T.Mesh(new T.CylinderGeometry(0.04, 0.04, W - 0.2, 12), M.metal); rod.rotation.z = Math.PI / 2; rod.position.set(0, 0.6, 0.05); g.add(rod);
    [M.wireR, M.wireK, M.wireW].forEach(function(mat, i){
      var x = (i - 1) * 0.62;
      var core = new T.Mesh(new T.CylinderGeometry(0.31, 0.31, 0.46, 32), mat); core.rotation.z = Math.PI / 2; core.position.set(x, 0.6, 0.05); core.castShadow = true; g.add(core);
      [-1, 1].forEach(function(s){ var f = new T.Mesh(new T.CylinderGeometry(0.37, 0.37, 0.03, 32), M.blackD); f.rotation.z = Math.PI / 2; f.position.set(x + s * 0.24, 0.6, 0.05); g.add(f); });
    });
    latches(g, h); g.userData.h = h; return g;
  }
  function tote(){
    var g = new T.Group(), w = 2.0, d = 1.2;
    rb(w + 0.05, 0.12, d + 0.05, 0.03, M.orange, 0, 0.06, 0, g);
    rb(w, 0.85, d, 0.05, M.black, 0, 0.55, 0, g);
    rb(w + 0.02, 0.1, d + 0.02, 0.03, M.orange, 0, 0.95, 0, g);
    for (var i = -1; i <= 1; i++){ rb(0.55, 0.42, 0.06, 0.02, M.blackD, i * 0.64, 0.45, d / 2 + 0.03, g); rb(0.55, 0.04, 0.07, 0.01, M.orange, i * 0.64, 0.67, d / 2 + 0.03, g); }
    var arc = new T.Mesh(new T.TorusGeometry(0.62, 0.05, 10, 32, Math.PI), M.black); arc.position.set(0, 0.98, 0); arc.castShadow = true; g.add(arc);
    plane(0.4, 0.216, M.klein, 0, 0.8, d / 2 + 0.065, g);
    g.userData.h = 1.6; g.userData.top = 1.0; return g;
  }
  function knect(){
    var g = new T.Group();
    rb(1.35, 0.28, 0.85, 0.04, M.black, 0, 0.14, 0, g);
    rb(1.37, 0.05, 0.87, 0.02, M.orange, 0, 0.2, 0, g);
    for (var i = 0; i < 6; i++){ var s = new T.Mesh(new T.CylinderGeometry(0.045, 0.045, 0.12, 12), M.metal); s.position.set(-0.5 + i * 0.2, 0.33, 0.15); g.add(s); }
    g.userData.h = 0.3; return g;
  }
  function bin(){ var g = new T.Group(); rb(0.3, 0.32, 0.58, 0.04, M.orange, 0.15, -0.16, 0, g); rb(0.05, 0.12, 0.58, 0.01, M.black, 0.02, 0.02, 0, g); rb(0.24, 0.05, 0.5, 0.01, M.bin, 0.16, -0.02, 0, g); return g; }
  function hooks(){ var g = new T.Group(); [-0.15, 0.15].forEach(function(z){ rb(0.05, 0.12, 0.08, 0.01, M.black, 0.02, 0.02, z, g); rb(0.2, 0.045, 0.05, 0.015, M.black, 0.11, -0.06, z, g); rb(0.045, 0.13, 0.05, 0.015, M.black, 0.2, 0, z, g); }); return g; }
  function cup(){ var g = new T.Group(); rb(0.05, 0.12, 0.16, 0.01, M.black, 0.02, 0.02, 0, g);
    var c = new T.Mesh(new T.CylinderGeometry(0.17, 0.15, 0.34, 24, 1, true), M.orange.clone()); c.material.side = T.DoubleSide; c.position.set(0.22, -0.12, 0); c.castShadow = true; g.add(c);
    var b = new T.Mesh(new T.CylinderGeometry(0.15, 0.15, 0.03, 24), M.orangeD); b.position.set(0.22, -0.28, 0); g.add(b); return g; }

  var MAKE = {
    KLE54801MB: rollingBase, KLE54802MB: plainBase,
    KLE54803MB: function(){ return tub(1.1); }, KLE54804MB: function(){ return tub(0.66); },
    KLE54821MB: function(){ return drawerUnit(1, 0.82); }, KLE54822MB: function(){ return drawerUnit(2, 1.0); }, KLE54823MB: function(){ return drawerUnit(3, 1.0); },
    KLE54806MB: compBox, KLE54809MB: compHalf, KLE54825MB: spool, KLE62202MB: tote, KLE65301KNECT: knect,
    KLE54815MB: bin, KLE54816MB: hooks, KLE54817MB: cup
  };
  var BASES = { KLE54801MB: 1, KLE54802MB: 1 }, RAIL = { KLE54815MB: 1, KLE54816MB: 1, KLE54817MB: 1 };
  var STACK_ORDER = ['KLE54803MB', 'KLE54822MB', 'KLE54821MB', 'KLE54825MB', 'KLE54823MB', 'KLE54804MB', 'KLE54806MB', 'KLE54809MB', 'KLE62202MB'];
  var MAX_H = 6.4, MAX_PER = 6;

  /* ---------- estado ---------- */
  var live = {};
  var focus = new T.Vector3(0, 1, 0), focusT = focus.clone(), dist = 10, distT = 10;
  var yaw = -0.34, pitch = 0.2, userTouched = false, lastInteract = 0;
  var emptyEl = host.querySelector('.mbx-3d-empty');
  var clamp = function(v){ return Math.max(0, Math.min(1, v)); };
  var eo = function(t){ t = clamp(t); return 1 - Math.pow(1 - t, 3); };
  var eio = function(t){ t = clamp(t); return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  function spawn(key, sku){
    var g = MAKE[sku](); g.userData.h = g.userData.h || 0; scene.add(g);
    live[key] = { group: g, sku: sku, born: performance.now(), target: new T.Vector3(), rot: 0, dying: 0, isNew: true };
    return live[key];
  }

  function layout(sel){
    var bases = [], stack = [], rails = [], loose = [];
    sel.forEach(function(it){
      if (!MAKE[it.sku]) return;
      for (var i = 0; i < Math.min(it.qty, MAX_PER); i++){
        var e = { key: it.sku + '#' + i, sku: it.sku };
        if (BASES[it.sku]) bases.push(e); else if (RAIL[it.sku]) rails.push(e); else if (it.sku === 'KLE65301KNECT') loose.push(e); else stack.push(e);
      }
    });
    stack.sort(function(a, b){ return STACK_ORDER.indexOf(a.sku) - STACK_ORDER.indexOf(b.sku); });
    var towers = (bases.length ? bases : [null]).map(function(b){ return { base: b, y: 0, last: null }; });
    var place = [], gap = W + 1.0;
    towers.forEach(function(t, i){
      t.x = (i - (towers.length - 1) / 2) * gap;
      if (t.base){ var o = live[t.base.key] || spawn(t.base.key, t.base.sku); t.y = o.group.userData.h; t.last = o; place.push({ o: o, x: t.x, y: 0, z: 0, rail: true, h: o.group.userData.h, base: true }); }
    });
    var ti = 0, half = null;
    stack.forEach(function(e){
      var o = live[e.key] || spawn(e.key, e.sku), ud = o.group.userData, t = towers[ti];
      if (t.y + ud.h > MAX_H && ti < towers.length - 1){ ti++; t = towers[ti]; half = null; }
      if (o.isNew && t.last){ t.last.latchAt = o.born; }       // la pieza de abajo abre y tranca sus cierres
      if (ud.half){
        if (half && half.t === t){ place.push({ o: o, x: t.x + W / 4, y: half.y, z: 0 }); half = null; t.last = o; return; }
        half = { t: t, y: t.y }; place.push({ o: o, x: t.x - W / 4, y: t.y, z: 0 }); t.y += ud.h; t.last = o; return;
      }
      half = null;
      place.push({ o: o, x: t.x, y: t.y, z: 0, rail: ud.h > 0.6 && e.sku !== 'KLE62202MB', h: ud.h });
      t.y += (ud.top || ud.h); t.last = o;
    });
    var slots = [];
    place.forEach(function(p){ if (!p.rail) return; var ry = p.y + (p.base ? 0.16 + 1.5 * 0.5 : p.h * 0.5);
      [1, -1].forEach(function(s){ slots.push({ x: p.x + s * (W / 2 + 0.06), y: ry, side: s }); }); });
    var cnt = new Map();
    function take(side){ for (var i = 0; i < slots.length; i++){ var s = slots[i]; if (s.side !== side) continue; var c = cnt.get(s) || 0; if (c < 2){ cnt.set(s, c + 1); return { x: s.x, y: s.y, z: c ? -0.38 : 0.34, side: s.side }; } } return null; }
    rails.forEach(function(e){
      var s = e.sku === 'KLE54816MB' ? (take(-1) || take(1)) : (take(1) || take(-1));
      if (!s){ if (live[e.key] && !live[e.key].dying) live[e.key].dying = performance.now(); return; }
      var o = live[e.key] || spawn(e.key, e.sku); o.rot = s.side > 0 ? 0 : Math.PI; o.rail = true;
      place.push({ o: o, x: s.x, y: s.y, z: s.z });
    });
    loose.forEach(function(e, i){ var o = live[e.key] || spawn(e.key, e.sku); place.push({ o: o, x: towers[towers.length - 1].x + W / 2 + 1.3, y: i * 0.3, z: 0.9 }); });
    towers.forEach(function(t){ if (!t.base) return; var hd = live[t.base.key].group.userData.handle; if (hd) hd.userData.target = Math.max(1.6, t.y - 0.05); });
    var keep = {};
    place.forEach(function(p){ p.o.target.set(p.x, p.y, p.z); p.o.isNew = false; for (var k in live) if (live[k] === p.o) keep[k] = 1; });
    Object.keys(live).forEach(function(k){ if (!keep[k] && !live[k].dying) live[k].dying = performance.now(); });
    var top = 0, minX = 0, maxX = 0;
    towers.forEach(function(t){ top = Math.max(top, t.y); minX = Math.min(minX, t.x - W / 2); maxX = Math.max(maxX, t.x + W / 2); });
    if (loose.length) maxX += 2.6;
    var hFit = Math.max(top + 1.5, 3.2), wFit = (maxX - minX) + 1.4;
    var fov = camera.fov * Math.PI / 180;
    distT = Math.max(hFit / 2 / Math.tan(fov / 2), wFit / 2 / Math.tan(fov / 2) / camera.aspect) * 1.1;
    focusT.set((minX + maxX) / 2, hFit * 0.45, 0);
    if (emptyEl) emptyEl.style.opacity = place.length ? 0 : 1;
  }

  /* ---------- animación: baja, se posa, encaja; los cierres de abajo se trancan ---------- */
  var last = performance.now();
  function frame(now){
    var dt = Math.min((now - last) / 1000, 0.05); last = now;
    var k = 1 - Math.pow(0.0008, dt);
    Object.keys(live).forEach(function(key){
      var o = live[key], g = o.group;
      if (o.dying){
        var a = (now - o.dying) / 300;
        if (a >= 1){ scene.remove(g); g.traverse(function(m){ if (m.geometry) m.geometry.dispose(); }); delete live[key]; return; }
        g.position.y = o.target.y + a * a * 1.5; g.scale.setScalar(1 - a * 0.6); return;
      }
      var u = (now - o.born) / 1000;
      if (u < 1.2){
        var hover = o.rail ? 0.05 : 0.14, startH = o.rail ? 1.2 : 3.2;
        var d1 = eo(u / 0.62), off = hover + (startH - hover) * (1 - d1);
        if (u >= 0.8){ var s = clamp((u - 0.8) / 0.12); off = hover * (1 - s * s); }
        if (u >= 0.92){ var b = clamp((u - 0.92) / 0.25); off = -0.018 * Math.sin(b * Math.PI) * (1 - b); }
        g.position.set(o.target.x + (1 - d1) * (o.rail ? 0 : 0.5), o.target.y + off, o.target.z);
        g.rotation.y = o.rot + (o.rail ? 0 : (1 - d1) * 0.35);
      } else { g.position.lerp(o.target, k); g.rotation.y = o.rot; }
      var L = g.userData.latches;
      if (L){
        var open = 0;
        if (o.latchAt){ var lu = (now - o.latchAt) / 1000; open = lu < 0.2 ? eo(lu / 0.2) : (lu < 0.95 ? 1 : 1 - eio((lu - 0.95) / 0.22)); }
        L.forEach(function(p){ p.rotation.x = open * 0.95; });
      }
      var hd = g.userData.handle;
      if (hd && hd.userData.target){
        var cur = hd.userData.cur || 1.6; cur += (hd.userData.target - cur) * k * 0.6; hd.userData.cur = cur;
        hd.children.forEach(function(c){ if (c.name === 'grip') c.position.y = cur; else { c.scale.y = cur; c.position.y = cur / 2; } });
      }
    });
    focus.lerp(focusT, k); dist += (distT - dist) * k;
    if (!userTouched || now - lastInteract > 4000) yaw = yaw + Math.sin(now / 4000) * dt * 0.08;
    camera.position.set(focus.x + Math.sin(yaw) * Math.cos(pitch) * dist, focus.y + Math.sin(pitch) * dist, focus.z + Math.cos(yaw) * Math.cos(pitch) * dist);
    camera.lookAt(focus);
    renderer.render(scene, camera);
    requestAnimationFrame(frame);
  }

  var drag = null, cv = renderer.domElement;
  cv.style.touchAction = 'pan-y';
  cv.addEventListener('pointerdown', function(e){ drag = { x: e.clientX, y: e.clientY }; userTouched = true; lastInteract = performance.now(); cv.setPointerCapture(e.pointerId); });
  cv.addEventListener('pointermove', function(e){ if (!drag) return;
    yaw -= (e.clientX - drag.x) * 0.008; pitch = Math.max(0.02, Math.min(0.9, pitch + (e.clientY - drag.y) * 0.004));
    drag = { x: e.clientX, y: e.clientY }; lastInteract = performance.now(); });
  ['pointerup', 'pointercancel'].forEach(function(n){ cv.addEventListener(n, function(){ drag = null; }); });
  function resize(){ var w = host.clientWidth, h = host.clientHeight; if (!w || !h) return;
    renderer.setSize(w, h, false); cv.style.width = w + 'px'; cv.style.height = h + 'px'; camera.aspect = w / h; camera.updateProjectionMatrix(); }
  if (window.ResizeObserver) new ResizeObserver(resize).observe(host); else window.addEventListener('resize', resize);
  resize(); requestAnimationFrame(frame);
  window.MBX3D = { update: layout };
})();
